module.exports = __webpack_public_path__ + "assets/6849329ec883a70b7c7aecb58aa86499.mp3";